import React, { useContext } from "react";
import { Box } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useTranslation } from "react-i18next";
import { handleNameTranslation } from "utilities/localesUtilities";
import useRolesPermissions from "hooks/useRolesPermissions";
import { useStyles } from "../AreasList.styles";
import { ActionButtons } from "./ActionButtons";
import { useAreasListContext } from "../context/AreasListContextProvider";
import { FailureDetailsSettingsContext } from "contexts/FailureDetailsSettings/FailureDetailsSettingsContext";
import { IFunctionalLocationItemProps } from "./interfaces";

export const FunctionalLocationItem: React.FC<IFunctionalLocationItemProps> = ({
    functionalLocation,
    areaId,
    isDraggingFunctionalLocations,
}) => {
    const { selectedFunctionalLocationId, handleSelectedFunctionalLocationId } =
        useContext(FailureDetailsSettingsContext);
    const { toggleFunctionalLocationTab, setFunctionalLocationToEdit, setFunctionalLocationToDelete } =
        useAreasListContext();
    const classes = useStyles();
    const { i18n } = useTranslation();
    const { CORPORATE_PERMISSIONS } = useRolesPermissions();

    return (
        <Box key={functionalLocation.functional_location_id}>
            <ListItemButton
                onMouseUp={() => {
                    toggleFunctionalLocationTab(
                        functionalLocation.functional_location_id,
                        isDraggingFunctionalLocations,
                    );
                }}
                sx={{
                    background:
                        selectedFunctionalLocationId === functionalLocation.functional_location_id!
                            ? "#fff !important"
                            : "unset !important",
                }}
                key={functionalLocation.functional_location_id!}
            >
                <ListItemText
                    primary={handleNameTranslation(i18n.language, functionalLocation.translation.translation_names)}
                    classes={{ primary: classes.optionsTitle }}
                />
                {CORPORATE_PERMISSIONS?.corporationPermissions?.canEditMachineCenters && (
                    <ActionButtons
                        onEdit={() => {
                            handleSelectedFunctionalLocationId(null);
                            setFunctionalLocationToEdit(functionalLocation, areaId);
                        }}
                        onDelete={() => setFunctionalLocationToDelete(functionalLocation)}
                    />
                )}
            </ListItemButton>
        </Box>
    );
};
